import styled, { css, keyframes } from 'styled-components'
import { PricingCardProps } from './index'

export const PricingCardWrapper = styled.div<
  Pick<PricingCardProps, 'planName'>
>`
  position: relative;
  margin-bottom: 2rem;

  ${({ planName }) =>
    planName === 'pro'
      ? css`
          transform: scale(1);
        `
      : css`
          transform: scale(0.9);
        `}
`
export const PricingCardTopBarLabel = styled.div<{
  showUndoPro?: boolean
  isCurrentPlan?: boolean
  isLoading?: boolean
}>`
  text-align: center;
  background-color: ${({ theme, isCurrentPlan }) =>
    isCurrentPlan ? '#41a6dc' : theme.brand.primary.background};
  padding: 5px 10px;
  top: ${(x) => (x.showUndoPro ? '20px' : '5px')};
  z-index: 1;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  color: white;
  font-weight: 600;
  position: absolute;
  width: 100%;

  p {
    font-size: 0.9rem;
  }

  span {
    font-weight: 600;
    margin-left: 0.4rem;
    ${({ isLoading }) =>
      isLoading
        ? css`
            color: #808080;
            cursor: not-allowed;
            text-decoration: none;
          `
        : css`
            color: #273649;
            text-decoration: underline;
            cursor: pointer;
          `}
  }
`
export const PricingCardTopBarWrapper = styled.div`
  margin-top: 30px;
`
export const PricingCardBox = styled.div<
  Pick<PricingCardProps, 'isActive' | 'isRecommended'>
>`
  width: 100%;
  max-width: 455px;
  min-height: 100%;
  border-radius: 8px;
  background: rgba(217, 222, 225, 0.15);
  padding: 1.85rem 1.6rem 1.85rem 1.6rem;

  ${({ isRecommended, isActive }) =>
    !isRecommended && isActive
      ? css`
          margin-top: 2rem;
        `
      : css``}
  ${({ isActive }) =>
    isActive
      ? css`
          // background: #fff;
          // box-shadow: -2px 0px 5px 0 rgb(44 44 44 / 14%);
          // border: 2px solid #cdcdcd;
        `
      : css`
          background: rgba(217, 222, 225, 0.15);
          margin-top: 30px;
        `}

  hr {
    border: 1px solid #d8d8d8;
    border-radius: 1.5px;
    width: 3.125rem;
    margin: 2.2rem 0 0.9rem 0;
  }

  /* h2 {
    font-size: 1.7rem;
    color: #1f1f1f;
    margin-bottom: 1.5rem;
  }*/

  button {
    margin-top: 0.875rem;
  }
`

const textHightligth = keyframes`
  from {
    opacity: 0;
    transform: translateY(5px) scale(1.5);
  }

  to {
    transform: translateY(-3px) scale(1);
    opacity: 1;
  }
`
export const PriceDiscount = styled.div<
  Pick<PricingCardProps, 'isYearlyChecked'>
>`
  position: absolute;
  top: -60%;
  font-size: 13px;
  color: rgb(58, 210, 159);
  white-space: nowrap;
  right: 0px;
  transform: translateY(-3px) scale(1);
  ${({ isYearlyChecked }) =>
    isYearlyChecked
      ? css`
          animation: ${textHightligth} 1.2s ease-out 1;
          //animation-delay: 1s;
        `
      : css`
          opacity: 0;
        `}
`
export const PriceStyled = styled.div`
  display: flex;
  align-items: center;
  font-weight: 600;
  position: relative;

  span {
    opacity: 0.5;
    margin-right: 0.35rem;
    position: absolute;
    font-size: large;
    top: 1px;
    left: -15px;
  }

  h2 {
    position: relative;
    margin: 0 0 10px 0;
    font-weight: bold;
  }
`
export const PricingCardHeaderStyled = styled.div`
  display: flex;
  flex: 1;
  min-height: 115px;
`
export const PlanHeaderRight = styled.div`
  width: 40%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  margin-left: 10px;
  padding-left: 10px;
  border-left: 2px dashed rgba(34, 36, 38, 0.15);
`
export const PlanHeaderLeft = styled.div`
  width: 100%;
`
export const PriceDescription = styled.p`
  opacity: 0.5;
  font-size: small;
  text-align: right;
`

export const PlanType = styled.p`
  text-transform: uppercase;
  font-size: smaller;
  letter-spacing: 0.7px;
  font-weight: 600;
  color: #41a6dc;
`
export const PlanName = styled.p<Pick<PricingCardProps, 'planName'>>`
  font-size: ${({ planName }) => (planName === 'pro' ? '1.7rem' : '1.4rem')};
  font-weight: 600;
  color: #1f1f1f;
  margin-bottom: 0 !important;
`
export const PlanDescription = styled.p<Pick<PricingCardProps, 'planName'>>`
  opacity: 1;
  margin-top: 10px;
  font-size: ${({ planName }) => (planName === 'pro' ? '1rem' : '.9rem')};
  min-width: 12.5rem;
`

export const FeaturesStyled = styled.ul`
  padding-left: 1.2rem;
  margin-top: 2.2rem;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 18px;

  li {
    margin-bottom: 1.2rem;
  }
  .feature-item-styled {
    max-width: 350px;
  }
`
